import { useEffect } from 'react';

const useEventListener = (event: string, listener: EventListener, useCapture?: boolean | EventListenerOptions) => {
  useEffect(() => {
    if (listener) {
      listener(null);
      window.addEventListener(event, listener, useCapture);

      return () => window.removeEventListener(event, listener, useCapture);
    }
  }, [event, listener, useCapture]);
};

export default useEventListener;
